import { FC, ReactElement } from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";

const Splash: FC = (): ReactElement => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "fixed",
        background: (theme) => theme.palette.primary.main,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          spacing={2}
          mt={3}
        >
          <CircularProgress
            size={30}
            sx={{
              color: "white",
            }}
          />
          <Typography color="white" variant="h6">
            Loading...
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default Splash;
